import React from 'react';
import { MailIcon } from 'lucide-react';
import { SubscribeForm } from '../whatsnew/SubscribeForm';
export function NewsletterCard({
  id
}: {
  id: string;
}) {
  return <div className="flex flex-col gap-6 rounded-[16px] bg-canvas-warm px-6 py-8 sm:px-10 lg:flex-row lg:items-center lg:justify-between" data-id="element-145" data-mp="1763ztvmvtbcf">
      <div className="flex items-start gap-4" data-id="element-146" data-mp="1gyjhssy6hzxb">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] bg-white text-brand" data-id="element-147" data-mp="1h0cmw3t58c37">
          <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-148" data-mp="o9mblo78rtkx" />
        </span>
        <div data-id="element-149" data-mp="o9uld782iirw">
          <p className="text-[20px] font-semibold tracking-[-0.02em] text-ink" data-id="element-150" data-mp="obfhv2dy0bse">One practical tip, every week</p>
          <p className="mt-1 text-[15px] text-ink-soft" data-id="element-151" data-mp="y7sby1degrno">Short, useful advice for running your business. No spam, unsubscribe anytime.</p>
        </div>
      </div>
      <SubscribeForm id={id} buttonLabel="Subscribe" successText="You’re subscribed. Look out for our next tip." align="left" className="lg:shrink-0" data-id="element-152" data-mp="24ncjz75e940d" />
    </div>;
}